// extracted by mini-css-extract-plugin
module.exports = {"root":"Small_root__1o947","upload":"Small_upload__1eAab","imageWrap":"Small_imageWrap__qvHzw","removeBtn":"Small_removeBtn__1GE86"};